    document.querySelectorAll('[slot="idle"].menus-wrapper-search .predictive-search__tab-content a.bold, [data-type="query"] a.bold,[slot="idle"].menus-wrapper-search  a').forEach(a => {
    
    a.addEventListener("click", e => {

    let anchorLink = e.target.closest('a').getAttribute("href");
    if(anchorLink.includes("/search")){
          e.preventDefault();
    
    let anchorURL = new URL(`https://${window.Shopify.shop}${anchorLink}`);
    let queryString = anchorURL.searchParams.get('q');
    e.target.closest("form").querySelector('[name="q"]').value = queryString;

      e.target.closest("predictive-search")._onInputChanged();
    }

    });
    });
window.applyCouponEvents = () => {

  document.querySelector('.remove-discount')?.addEventListener('click', function(e) {

  let target = e.target;

    let remove_coupon_trigger = false;
    if(e.target.classList.contains("remove-coupon-icon") || (e.target.closest(".icon-close") && e.target.closest(".icon-close").classList.contains("remove-coupon-icon"))) {
      remove_coupon_trigger = true;  
    }

    if(!remove_coupon_trigger){
      return;
    }
  if(!target.classList.contains("button")){
    target = e.target.closest(".button")
  }

  target.setAttribute("aria-busy", true);
  target.setAttribute("disabled", "disabled");

     fetch(`${window.Shopify.routes.root}discount/INVALIDCODE`, {
    method: 'GET'
  })
  .then(response => {

    if (response.ok) {

        return fetch(`${window.Shopify.routes.root}cart.js`);
    
    }
  }).then(response => response.json())
  .then(cart => {

        var discountCodes = [];
    
    if(cart.cart_level_discount_applications.length > 0){
        cart.cart_level_discount_applications.forEach(cart_level_discount_application => {

            if(cart_level_discount_application?.type == "discount_code") {
                discountCodes.push(cart_level_discount_application.title);
            }
        });
    }
 
    cart.items.forEach(item => {
    
        if(item.line_level_discount_allocations.length > 0){
            item.line_level_discount_allocations.forEach(line_level_discount_allocation => {
    
                if(line_level_discount_allocation?.type == "discount_code") {
                    discountCodes.push(line_level_discount_allocation.title);
                }
            });
        }
    });

  
    // Check if the discount was applied by examining the cart object
    const discountRemoved = !(discountCodes && discountCodes.length > 0);

    if (discountRemoved) {
     
       if(document.querySelector('.discount-message')){
        document.querySelector('.discount-message').classList.add('discount-success-message');
        document.querySelector('.discount-message').innerText =  window.themeVariables.strings.discountRemoveSuccessMessage;
      }

      // Reload the cart to reflect the discount
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      
    } else {
      
     // Show an error message if the discount code is invalid
      if(document.querySelector('.discount-message')){
        document.querySelector('.discount-message').classList.add('discount-error-message');
        document.querySelector('.discount-message').innerText = window.themeVariables.strings.discountRemoveErrorMessage;
      }
    }

    target.removeAttribute("disabled");
    target.removeAttribute("aria-busy");
  })
  .catch(error => {
    console.error('Error applying discount code:', error);

        target.removeAttribute("disabled");
    target.removeAttribute("aria-busy");
  });
  
});

  if(!window.matchMedia("(max-width: 767px)").matches) {
  document.querySelector('[name="discount" ]')?.addEventListener("keypress", e => {
    if(e.key == "Enter"){
      document.querySelector('.apply-discount')?.click();
    }
});
  }
document.querySelector('.apply-discount')?.addEventListener('click', function(e) {

  let target = e.target;

  if(!target.classList.contains("button")){
    target = e.target.closest(".button")
  }

  const discountCode = document.querySelector('[name="discount"]').value;
  if (discountCode) {

      target.setAttribute("aria-busy", true);
  target.setAttribute("disabled", "disabled");
    
     fetch(`${window.Shopify.routes.root}discount/${discountCode}`, {
    method: 'GET'
  })
  .then(response => {

    if (response.ok) {

        return fetch(`${window.Shopify.routes.root}cart.js`);
    
    }
  }).then(response => response.json())
  .then(cart => {

        var discountCodes = [];
    
    if(cart.cart_level_discount_applications.length > 0){
        cart.cart_level_discount_applications.forEach(cart_level_discount_application => {

            if(cart_level_discount_application?.type == "discount_code") {
                discountCodes.push(cart_level_discount_application.title);
            }
        });
    }

    cart?.items?.forEach(line_item => {

          if(line_item.line_level_discount_allocations.length > 0){
        line_item.line_level_discount_allocations.forEach(line_level_discount_allocation => {

            if(line_level_discount_allocation?.discount_application?.type == "discount_code") {
                discountCodes.push(line_level_discount_allocation.discount_application.title);
            }
        });
    }
      
    })
    
    cart.items.forEach(item => {
    
        if(item.line_level_discount_allocations.length > 0){
            item.line_level_discount_allocations.forEach(line_level_discount_allocation => {
    
                if(line_level_discount_allocation?.type == "discount_code") {
                    discountCodes.push(line_level_discount_allocation.title);
                }
            });
        }
    });

  
    // Check if the discount was applied by examining the cart object
    const discountApplied = discountCodes && discountCodes.length > 0;

    if (discountApplied) {
     
       if(document.querySelector('.discount-message')){
        document.querySelector('.discount-message').classList.add('discount-success-message');
        document.querySelector('.discount-message').innerText = 'Discount code applied';
      }

      // Reload the cart to reflect the discount
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      
    } else {
          // Show an error message if the discount code is invalid
      if(document.querySelector('.discount-message')){
        document.querySelector('.discount-message').classList.add('discount-error-message');
        document.querySelector('.discount-message').innerText = 'Invalid discount code';
      }
    }

    target.removeAttribute("disabled");
    target.removeAttribute("aria-busy");
  })
  .catch(error => {
    console.error('Error applying discount code:', error);

        target.removeAttribute("disabled");
    target.removeAttribute("aria-busy");
  });
  }
});

}
window.sizeButtonsEventBindings = () => {

  if(document.querySelectorAll('.product-card__inline-size-buttons')) {

  document.querySelectorAll('.product-card__inline-size-buttons').forEach(inlineButtons => {

    let sizeRadioButtons = inlineButtons.querySelectorAll("[type='radio']");

    if(sizeRadioButtons) {

      sizeRadioButtons.forEach(sizeRadioButton => {

        let currentForm = sizeRadioButton.closest("form");
        
        if(sizeRadioButton.hasAttribute("disabled")) {

          document.querySelector(`label[for="${sizeRadioButton.getAttribute("id")}"]`).classList.add("is-disabled");
					document.querySelector(`label[for="${sizeRadioButton.getAttribute("id")}"]`).classList.add("BIS_trigger");
        }

        sizeRadioButton.checked = false;
        sizeRadioButton.addEventListener("change", e => {

          if(e.target.value){

            if(e.target.closest(".product-card,.horizontal-product-with-inline-buttons").querySelector("pill-loader")){
              e.target.closest(".product-card,.horizontal-product-with-inline-buttons").querySelector("pill-loader").setAttribute("aria-busy", true);
            }
            currentForm.querySelector('[name="id"]').value = e.target.value;

            currentForm.querySelector('[type="submit"]').click();

             e.target.checked = false;
          }
          
        });
      })
    }
});
}
};

// function toggleFilters() {
//     var toggleButton = document.getElementById('toggleButton');
//     if (toggleButton.innerText.includes("Hide Filter")) {
//       toggleButton.innerHTML = `{%- render 'icon' with 'filter', class: 'icon-subdued' -%} {{- 'collection.faceting.show_filters' | t -}}`;
//     } else {
//       toggleButton.innerHTML = `{%- render 'icon' with 'filter', class: 'icon-subdued' -%} {{- 'collection.faceting.hide_filters' | t -}}`;
//     }
//     document.getElementById('main').classList.toggle('show-filters');
// }

 
window.sizeButtonsClickEventBindings = () => {
  let variantPicker = document.querySelector(".product-info__variant-picker");

  if(!variantPicker) {
    return;
  }

  let sizeOptionFieldsets = variantPicker.querySelectorAll(".variant-picker__option[data-size-option]");

  if(!sizeOptionFieldsets.length) {
    return;
  }

  let updatePdpSizeSelectionState = () => {
    let productBuyButtons = document.querySelector(".product-info__buy-buttons");
    let addToCartLabel = productBuyButtons?.querySelector('.ProductForm__AddToCart div');
    let addToCartText = productBuyButtons?.querySelector("buy-buttons")?.dataset.atcText;
    let dynamicPaymentButtons = document.querySelector(".dynamic-payment-buttons-wrapper");
    let hasCompletedSelection = Array.from(sizeOptionFieldsets).every(optionFieldset => {
      let selectedInput = optionFieldset.querySelector('input:not(.size-chart-input):checked, select[name^="option"]');

      return selectedInput && selectedInput.value;
    });

    sizeOptionFieldsets.forEach(optionFieldset => {
      let selectedInput = optionFieldset.querySelector('input:not(.size-chart-input):checked, select[name^="option"]');
      let selectPrompt = optionFieldset.querySelector("[data-size-option-select]");
      let optionName = optionFieldset.querySelector("[data-size-option-name]");

      if(selectedInput?.value) {
        optionFieldset.classList.remove("has-size-error");
      }

      if(selectPrompt) {
        selectPrompt.classList.toggle("hidden", !!selectedInput?.value);
      }

      if(optionName) {
        optionName.classList.toggle("hidden", !selectedInput?.value);
      }
    });

    if(addToCartLabel && addToCartText) {
      addToCartLabel.innerText = hasCompletedSelection ? addToCartText : window.themeVariables.strings.sizeOptionError.replace(" to add to cart", "");
    }

    if(dynamicPaymentButtons) {
      dynamicPaymentButtons.classList.toggle("hidden", !hasCompletedSelection);
    }
  };

  sizeOptionFieldsets.forEach(optionFieldset => {
    optionFieldset.querySelectorAll("input, select").forEach(sizeInput => {
      sizeInput.addEventListener("change", updatePdpSizeSelectionState);
    });
  });

  updatePdpSizeSelectionState();
};

window.modelButtonClickEventBindings = () => {
  if(document.querySelectorAll('.model-product-info')){
      document.querySelectorAll('.model-product-info').forEach(element => {
      element.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.toggle("model-information");
      });
    });
  }
};

window.inlineButtonsTriggerEventBindings = () => {
if(document.querySelectorAll(".inline-buttons-trigger")) {
  document.querySelectorAll(".inline-buttons-trigger").forEach(inlineButtonTrigger => {
    inlineButtonTrigger.addEventListener("click", e => {
    if(e.target.closest(".horizontal-product-with-inline-buttons")) {
      e.target.closest(".horizontal-product-with-inline-buttons").querySelector(".is-horizontal-product-card").classList.remove("hidden");
      inlineButtonTrigger.classList.add("hidden");
      e.target.closest(".horizontal-product-with-inline-buttons").classList.add("inline-buttons-shown");
      sizeButtonsEventBindings();
    }
    });
  })
}
};

window.handleErrorBlockSwatchButtons = () => {
  document.querySelectorAll('fieldset.variant-picker__option.has-size-error').forEach(optionFieldset => {
    optionFieldset.querySelectorAll('label.block-swatch').forEach($label => {
      $label.addEventListener("click", e => {
        e.target.closest('.variant-picker__option').classList.remove('has-size-error');
      });
    });
  });
};

sizeButtonsEventBindings();
sizeButtonsClickEventBindings();
modelButtonClickEventBindings();
inlineButtonsTriggerEventBindings();
applyCouponEvents();
handleErrorBlockSwatchButtons();
document.addEventListener("cart:change", e => {
setTimeout(() => {
  inlineButtonsTriggerEventBindings();
  applyCouponEvents();
}, 2500);

});
document.addEventListener("cart:refresh", e => {

setTimeout(() => {
  inlineButtonsTriggerEventBindings();
  applyCouponEvents();
}, 2500);

});
function toggleAccordion(elem) {
	var $this = elem;
	if($this.classList.contains('active')) {
		$this.classList.remove('active');
		$this.closest('.footer__block').classList.remove('active');
	} else {
		$this.classList.add('active');
		$this.closest('.footer__block').classList.add('active');
	}
}

/* Size guide */
 
if(document.querySelector('#size-chart-options-dropdown')){
   document.querySelector('#size-chart-options-dropdown').addEventListener('change', e => {
				switchTabs(e.target);
 });
}

 document.querySelectorAll('[name="unit_type"]').forEach(unitType => {
	 unitType.addEventListener('change', e => {
		 let unitTypeValue = e.target.value;
		 if( unitTypeValue == "in") {
			 switchUnits('value-in-in', 'value-in-cm')
		 }
		if( unitTypeValue == "cm") {
			 switchUnits('value-in-cm', 'value-in-in')
		 }
 });
 });
function switchTabs(elem) {
	var $val = elem.value;
	var $container = elem.closest('.sc-modal-content');
	$container?.querySelectorAll('.size-chart-tabs')?.forEach(function(el) {
		el.style.display = 'none';
	});
	document.getElementById($val) ? document.getElementById($val).style.display = 'block': '';
}

function switchSizeUnits($this) {

   if($this.checked){
      switchUnits('value-in-cm', 'value-in-in', $this)
   } else {
      switchUnits('value-in-in', 'value-in-cm', $this)
   }
}
function switchUnits(showElem, hideElem,  $this) {

	var $showElement =  $this.closest('[x-data="size_chart_object"],.size-guide-drawer').querySelectorAll('.' + showElem);
	var $hideElement =  $this.closest('[x-data="size_chart_object"],.size-guide-drawer').querySelectorAll('.' + hideElem);

	$hideElement?.forEach(function(el) {
		el.style.display = 'none';
	});
	$showElement?.forEach(function(el) {
		el.style.display = 'block';
	});
}

window.tabImageChangeEventBindings = () => {
function hideAllSizeChartTabImages() {
		 for(tabImage of document.querySelectorAll(".tab-image")) {

	 tabImage.style.display = "none";
}
}
function handleSizeCharts() {
	if(window.matchMedia("(max-width: 767px)").matches) {

		hideAllSizeChartTabImages();
      if (document.querySelector("#tab-tops-image")) {
  		document.querySelector("#tab-tops-image").style.display = "block";
      }
      if (document.querySelector('#size-chart-options-dropdown')) {
	document.querySelector('#size-chart-options-dropdown').addEventListener('change', e => {
		e.preventDefault();
		let sizeChartCurrentTabValue = e.target.value;
		 let $currentSizeChartImage = document.querySelector(`#${sizeChartCurrentTabValue}-image`);
		 hideAllSizeChartTabImages();
		if ($currentSizeChartImage) {
			$currentSizeChartImage.style.display = "block";
		}
	 
	 
});
      }
}
}
handleSizeCharts();
window.addEventListener('resize', function(event){
	handleSizeCharts();
});
}
tabImageChangeEventBindings();

window.sizeChangeEventBindings = () => {
if(document.getElementById('size-chart-options-dropdown')){
  
  document.getElementById('size-chart-options-dropdown').addEventListener('change', function(e) {
  var selectElement = e.target;
  var selectedValue = selectElement.value;
  var targetElement = document.getElementById(selectedValue);
  
  if (selectedValue === "tab-menswear") {
    document.querySelector(".menswear-wrapper")?.classList.remove("hide");
    
    document.querySelectorAll(".measure-wrapper")?.forEach(function(element) {
      element.classList.add("hide");
    });
    document.getElementById("tab-dressSize") ? document.getElementById("tab-dressSize").style.display = 'none': "";
  } else {
    document.querySelector(".menswear-wrapper")?.classList.add("hide");
    document.querySelectorAll(".measure-wrapper")?.forEach(function(element) {
      element.classList.remove("hide");
    });
    document.getElementById("tab-dressSize") ? document.getElementById("tab-dressSize").style.display = 'block': '';
  }
});
}
};

sizeChangeEventBindings();

window.measureClickEventBindings = () => {
  document.querySelectorAll('.how-measure').forEach(function(element) {
    element.addEventListener('click', function(e) {
      if (e.target.classList.contains('scroller')) {
        const target = e.target.getAttribute('data-target');
        const targetElement = document.querySelector(target);
  
        const parentDiv = targetElement?.closest('div');
        const parentDivHasHideClass = parentDiv && parentDiv.classList.contains('hide');
  
        if (!parentDivHasHideClass) {
          targetElement?.scrollIntoView({ 
            behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto" 
          });
  
        }
      }
    });
  });
}

measureClickEventBindings();


window.showMoreColors = $this => {

  $this.classList.add("hidden");
  if($this.closest(".variant-picker__option-values")) {
    $this.closest(".variant-picker__option-values").querySelectorAll('[data-product-id]').forEach(colorItem => {

      colorItem.classList.remove("hidden");
    });
    document.querySelector("body").classList.add("all-colors-shown");
  }
}
window.showMoreSuggestions = $this => {
  $this.setAttribute("hidden", true);
  $this.closest('[data-type="query"]').querySelectorAll('a').forEach(queryItem => {
    queryItem.removeAttribute("hidden");
  });
}
window.showMoreImages = $this => {

  $this.classList.add("hidden");
  if($this.closest("product-gallery")) {
    $this.closest("product-gallery").querySelectorAll('.product-gallery__media').forEach(productGalleryMedia => {

      productGalleryMedia.classList.remove("desktop-hidden");
    });
    document.querySelector("body").classList.add("all-images-shown");
  }
}

window.addToWishlist = (productId, wishlistElement) => {
	let wishlistProducts = localStorage.getItem('theme:wishlist-products') || '[]';
     productId = parseInt(productId, 10);
    wishlistProducts = JSON.parse(wishlistProducts);
	
	if(wishlistElement.classList.contains('added-wishlist')) {
		wishlistElement.classList.remove('added-wishlist');
        let productIndexToRemove = wishlistProducts.indexOf(productId);
        if(productIndexToRemove > -1) {
          wishlistProducts.splice(productIndexToRemove, 1);
        }
      
		localStorage.setItem('theme:wishlist-products', JSON.stringify(wishlistProducts));

	} else {
      wishlistProducts.push(productId);
      localStorage.setItem('theme:wishlist-products', JSON.stringify(wishlistProducts));
		wishlistElement.classList.add('added-wishlist');
	}

  if(document.querySelector("wishlist-products")){
    document.querySelector("wishlist-products").loadWishlistProducts();
  }

  handleWishlist();
}

window.handleWishlist = () => {
  	let wishlistProducts = localStorage.getItem('theme:wishlist-products') || '[]';
    wishlistProducts = JSON.parse(wishlistProducts);
	if(wishlistProducts.length) {
      wishlistProducts.forEach(wishlistProduct => {
        var wishlistElements = document.querySelectorAll(`.add-to-wishlist[data-product-id="${wishlistProduct}"]`);

        wishlistElements.forEach(wishlistElement => {
          if(wishlistElement) {
          wishlistElement.classList.add('added-wishlist');
        }
        });
        
      });
      document.querySelector(".header_wishlist_icon")?.classList.add("has-wishlist-items");
	} else {
      document.querySelector(".header_wishlist_icon")?.classList.remove("has-wishlist-items");
    }
};
document.addEventListener("DOMContentLoaded", function() {
handleWishlist();
});
document.querySelector("body").addEventListener("click", e => {
    
    if(!e.target.closest("predictive-search") && document.querySelector("predictive-search")?.querySelector('[slot="results"]').style.opacity == "1") {
       document.querySelector("predictive-search")._searchForm.reset();
      document.querySelector("predictive-search")._onSearchCleared();
      
    }
});

document.querySelectorAll(".multiple-collection-link").forEach(multiColLink => {
 let section = multiColLink.closest(".shopify-section--featured-multiple-collection");
 let collectoinBlockId = multiColLink.getAttribute("id");
  multiColLink.addEventListener("click", e => {
    section.querySelectorAll(".multiple-collection-link").forEach(link => link.classList.remove("active-collection"));
    multiColLink.classList.add("active-collection");
    
    if(section.querySelector(".view-detail-button") != null) {
      section.querySelector(".view-detail-button").setAttribute("href", multiColLink.getAttribute("is"));
    }
    
    section.querySelectorAll(".multiple-collection-item").forEach(item => item.setAttribute("hidden", true));
     section.querySelector(`.multiple-collection-item[data-id="${collectoinBlockId}"]`).removeAttribute("hidden");
  })


  
})
const resetSearchDrawer = $this => {
   $this.closest("form").querySelector('.predictive-search')._searchForm.reset();
  $this.closest("form").querySelector('.predictive-search')._onSearchCleared();
    
};

const triggerZoom = $this => {

  if($this.querySelector("[is='product-zoom-button'")){
    $this.querySelector("[is='product-zoom-button'").click();
  }
  
};
window.initCountdownTimer = ($date, $timerContainer) => {

  // Set the date we're counting down to
  let countdown_date = new Date($date).getTime();

  setTimeout(function(){
  $timerContainer.closest(".countdown-timer-content-wrapper").classList.remove("hide");
   $timerContainer.closest(".countdown-timer-content-wrapper").classList.remove("hide-timer");
  }, 1000);
  // Update the count down every 1 second
  var countdown_timer_interval = setInterval(function() {

    // Get today's date and time
    let now = new Date().getTime();

    // Find the distance between now and the count down date
    let distance = countdown_date - now;

    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in an element with id="countdown-timer-container"
    const daysSpan = $timerContainer.querySelector('.days');
    const hoursSpan = $timerContainer.querySelector('.hours');
    const minutesSpan = $timerContainer.querySelector('.minutes');
    const secondsSpan = $timerContainer.querySelector('.seconds');

    function padWithZero(number) {
    return number.toString().padStart(2, '0');
    }
    
    if(daysSpan){
      daysSpan.innerHTML = padWithZero(days);
    }
    if(hoursSpan){
      hoursSpan.innerHTML = padWithZero(hours);
    } 
    if(minutesSpan){
      minutesSpan.innerHTML = padWithZero(minutes);
    }
    if(secondsSpan){
      secondsSpan.innerHTML = padWithZero(seconds);
    }
   

    $timerContainer.closest(".countdown-timer-content-wrapper").classList.remove("hide-timer");
    // If the count down is over, write some text or do some other action
    if (distance < 0) {
      clearInterval(countdown_timer_interval);

      //$timerContainer.style.display = "none";

    }
  }, 1000);
};
